// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"a62286f3","166":"23efc6c9","675":"4f3969ff","926":"edc9a9e4"}[chunkId] + ".css";
};